import http from "@http"

//列表  不分页
export function getPillarAll(data) {
    return http({
        url: '/lskj-data/api/data/pillar/all',
        method: "post",
        data
    })
}
//列表  分页
export function getPillarList(data) {
    return http({
        url: '/lskj-data/api/data/pillar/list',
        method: "post",
        data
    })
}

//查询单条
export function pillarById(data) {
    return http({
        url: `/lskj-data/api/data/pillar/byId?id=${data.id}`,
        method: "get",
    })
}

//添加
export function pillarAdd(data) {
    return http({
        url: '/lskj-data/api/data/pillar/add',
        method: "post",
        data
    })
}

//修改
export function updetePillar(data) {
    return http({
        url: `/lskj-data/api/data/pillar`,
        method: "put",
        data
    })
}
//删除
export function deletePillar(data) {
    return http({
        url: `/lskj-data/api/data/pillar?ids=${data.ids}`,
        method: "delete",
        data
    })
}